
/**
 * Toggles the 'focused' class on the parent '.form-group' based on the input's state.
 *
 * @param {jQuery} element - The jQuery-wrapped form control element.
 * @param {Event} e - The event object.
 */
function toggleFocusedState(element, e) {
    var $element = $(element);
    var $formGroup = $element.closest('.form-group');
    var $firstOption = $element.find('option:not(optgroup option):first-child');
    var isSelected = $firstOption.is(':selected');
    var hasValue = element.value.length > 0;

    if ($element.is('select')) {
        $formGroup.toggleClass('focused', (e.type === 'focus' || hasValue) && (!isSelected || $formGroup.hasClass('default-set')));
    } else {
        $formGroup.toggleClass('focused', (e.type === 'focus' || hasValue));
    }
}

/**
 * Initialize Float Labels
 * @param {jQuery} selector - The jQuery-wrapped form control element.
 */
function init() {
    var floatInputs = "input[type='date'], input[type='email'], input[type='password'], input[type='search']"
        + ", input[type='tel'], input[type='number'], input[type='text']:not([hidden]), input[type='url'], select, textarea";

    var $formControls = $(floatInputs);

    $('form').addClass('floating'); // add global utility class to forms for manipulating specific elements

    $formControls.each(function () {
        var $currEl = $(this);
        var $formGroup = $currEl.closest('.form-group');

        $formGroup.addClass('floating-label');
        // detect whether select has an empty "placeholder" value as first option, or an actual value
        if ($currEl.is('select')) {
            var $firstOption = $currEl.find('option:not(optgroup option):first-child');
            $formGroup.addClass('floating-select');

            if ($.trim($firstOption.html()).length) {
                $formGroup.addClass('default-set');
            }
        }
    });


    // Use mkfl namespaced events so that they can be safely re-bound 
    $formControls.off('.mkfl')
        .on('focus.mkfl blur.mkfl change.mkfl input.mkfl', function (e) {
            toggleFocusedState(this, e);
        });

    // Apply the focus class based on current value of form controls
    $formControls.each(function () {
        toggleFocusedState(this, {});
    });
}

module.exports = function () {
    init();

    $('body').on('initFloatLabels', function () {
        init();
    });
};